import React,{Fragment} from "react";
import Modal from "../../layout/Modal";
import PropTypes, {ReactComponentLike} from "prop-types";
import Button, {ButtonProps} from "../Button";
import Portal from "../../layout/Portal";

type AskBeforeUnloadProps = {
    buttons?: (ButtonProps|ReactComponentLike)[],
    saveable?: boolean,
    resolve: (reason?: any) => void,
    reject: (reason?: any) => void,
};

class AskBeforeUnload extends React.Component<AskBeforeUnloadProps, {isLoading: boolean}> {

    state = {
        isLoading: false
    }

    static propTypes = {
        buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
        saveable: PropTypes.bool
    }

    render() {
        return <Portal>
            <Modal
                state="on"
                theme="default"
                header={this.props.saveable === undefined || this.props.saveable === true ? "Mentés" : "Elvetés"}
                buttons={this.props.buttons || [
                    ...(this.props.saveable === undefined || this.props.saveable === true ? [
                        <Button
                            color="primary"
                            onClick={async () => {
                                this.setState({isLoading: true});
                                await this.props.resolve(true);
                                this.setState({isLoading: false});
                            }}
                        >
                            Mentés
                        </Button>
                    ] : []),
                    <Button
                        color="default"
                        onClick={async () => {
                            this.setState({isLoading: true});
                            await this.props.resolve(false);
                            this.setState({isLoading: false});
                        }}
                    >
                        Elvetés
                    </Button>,
                    <Button
                        color="default"
                        onClose={true}
                        onClick={async () => {
                            this.setState({isLoading: true});
                            await this.props.reject();
                            this.setState({isLoading: false});
                        }}
                    >
                        Mégse
                    </Button>,
                ]}
            >
                {this.props.saveable === undefined || this.props.saveable === true ?
                    <Fragment>Akarod menteni a változtatásokat?</Fragment> :
                    <Fragment>Biztos elveted a változtatásokat?</Fragment>}
            </Modal>
        </Portal>;
    }
} 
export default AskBeforeUnload;